import { t } from '@/utils/i18n-helper'

export function translateMenuTitle(title, defaultValue = '') {
  if (!title) {
    return defaultValue || ''
  }

  return t(title, defaultValue || title)
}

export function formatMenuTitle(menuName, portal = '') {
  const translatedMenuName = translateMenuTitle(menuName, menuName)
  return portal ? `${portal}__${translatedMenuName}` : translatedMenuName
}

export default translateMenuTitle
